import { Sector, SectorValues } from '@/domain/impact/impact.entity';
import {
  AccommodationType,
  AccommodationTypeValues,
  ImpactCo2Answer,
  Source,
  SourceValues,
  ValuesAccommodation,
} from '@/domain/impact-co2/entities/question.entity';
import { validateValueInType } from '@/domain/utils/validate-value-in-type';

import { QuestionAccommodationDto } from './dto.type';

export class QuestionAccommodationMapper {
  static dtoToEntity(
    dto: QuestionAccommodationDto,
  ): ImpactCo2Answer<ValuesAccommodation> {
    return {
      id: dto.id,
      userId: dto.userId,
      sector: validateValueInType<Sector>(dto.sector, SectorValues),
      category: 'ACCOMMODATION',
      isExternal: dto.isExternal,
      source: validateValueInType<Source>(dto.source || '', SourceValues),
      values: {
        accommodationType: validateValueInType<AccommodationType>(
          dto.accommodationType,
          AccommodationTypeValues,
        ),
        numberOfNights: dto.numberOfNights,
        label: dto.label || '',
        score: dto.score || 0,
        tags:
          dto?.tags?.values?.map((tag) => ({ id: tag.id, name: tag.name })) ||
          [],
      },
    };
  }

  static entityToDto(
    answer: ImpactCo2Answer<ValuesAccommodation>,
    projectId: number,
  ): Omit<QuestionAccommodationDto, 'id' | 'userId' | 'score' | 'isExternal'> {
    return {
      projectId: projectId,
      sector: answer.sector,
      accommodationType: answer.values.accommodationType,
      numberOfNights: answer.values.numberOfNights,
      label: answer.values.label || '',
      source: answer.source !== '' ? answer.source : undefined,
      tags: { values: answer.values.tags },
    };
  }
}
